export default __webpack_public_path__ + "static/media/fb.636688f0.png";